import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks/useTypedQuery";

import type { Dealer } from "models";
import type { LicenseItem, LicenseResponse, PaginatedHistoricalInvoices } from "modules/LocationLicenseOverview/queryKeys";

type PaginatedInvoice = {
  dealer: number;
  data: Record<number, PaginatedHistoricalInvoices>;
};

export type PaginatedInvoicesType = {
  data: PaginatedInvoice[];
};

export type DealerLicensesDashboardFilters = {
  dealer: Dealer | null;
};

const component = "DealerLicenseOverview";

export const DealerLicenseQueryKeys = {
  paginatedInvoices: localQueryKey<PaginatedInvoicesType>({ component, data: "paginatedInvoices" }),
  filters: localQueryKey<DealerLicensesDashboardFilters>({ component, data: "filters" }),
  invoices: backendQueryKey<PaginatedHistoricalInvoices>({ component, baseUrl: ENV.exactBaseURL, endpoint: "/invoices/list" }),
  licenses: backendQueryKey<LicenseResponse>({ component, baseUrl: ENV.exactBaseURL, endpoint: "/licenses/list" }),
  licenseItems: backendQueryKey<LicenseItem[]>({ component, baseUrl: ENV.exactBaseURL, endpoint: "/licenses/items/list" })
};
